var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Log") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P1-28-1",
    transform: "translate(-164.000000, -721.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log",
    transform: "translate(164.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD32-Stroke",
    stroke: "currentColor",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 12.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2.625 C12.6102253,2.625 13.1069739,3.11085171 13.1245204,3.71682972 L13.125,3.75 L13.125,10.875 L20.25,10.875 C20.8713203,10.875 21.375,11.3786797 21.375,12 C21.375,12.6102253 20.8891483,13.1069739 20.2831703,13.1245204 L20.25,13.125 L13.125,13.125 L13.125,20.25 C13.125,20.8713203 12.6213203,21.375 12,21.375 C11.3897747,21.375 10.8930261,20.8891483 10.8754796,20.2831703 L10.875,13.125 L3.75,13.125 C3.12867966,13.125 2.625,12.6213203 2.625,12 C2.625,11.3897747 3.11085171,10.8930261 3.71682972,10.8754796 L10.875,10.875 L10.875,3.75 C10.875,3.12867966 11.3786797,2.625 12,2.625 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.d6905bcc.svg";
export { ForwardRef as ReactComponent };